import {
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
  getAudienceSlug,
} from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import Artifact from "./Artifact";
import CompareModal from "./CompareModal";
import { getAudienceEmoji } from "posts/constants";

function ShoppingListCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderContent = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <>
            <Artifact
              imageUrl="/images/profile-tough-cookies-brands-lowes.png"
              imageAlt="Lowes logo"
              title="Lowe's"
              subtitle="Home Improvement"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.lowes.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profile-tough-cookies-commerce-blair.png"
              imageAlt="Blair logo"
              title="Blair"
              subtitle="Clothing"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.blair.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-commerce-bhg.png"
              imageAlt="Better Homes and Gardens logo"
              title="BHG"
              subtitle="Lifestyle"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.bhg.com/"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <>
            <Artifact
              imageUrl="/images/profile-tough-cookies-brands-lowes.png"
              imageAlt="Lowe's logo"
              title="Lowe's"
              subtitle="Home Improvement"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.lowes.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profile-dont-tread-commerce-kohls.png"
              imageAlt="Kohl's logl"
              title="Kohl's"
              subtitle="Department Store"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.kohls.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-commerce-realtor.png"
              imageAlt="realtor.com logo"
              title="realtor.com"
              subtitle="Real Estate"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.realtor.com/"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-peoplepower-commerce-gap.png"
              imageAlt="Gap logo"
              title="Gap"
              subtitle="Clothing"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.gap.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-peoplepower-commerce-ikea.png"
              imageAlt="Ikea logo"
              title="Ikea"
              subtitle="Furniture"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.ikea.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-peoplepower-commerce-sephora.png"
              imageAlt="Sephora logo"
              title="Sephora"
              subtitle="Beauty"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.sephora.com/"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-commerce-apartments.png"
              imageAlt="Apartments.com logo"
              title="Apartments.com"
              subtitle="Housing"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.apartments.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-commerce-fashionnova.png"
              imageAlt="Fashion Nova logo"
              title="Fashion Nova"
              subtitle="Clothing"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.fashionnova.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-commerce-nike.png"
              imageAlt="Nike logo"
              title="Nike"
              subtitle="Footwear"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.nike.com/"
              small={small}
            />
          </>
        );
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Shopping List
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>
            Compare Audiences – Shopping List
          </CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default ShoppingListCard;
